<div class="dialogContent">
    <mat-toolbar color="primary">
        <div fxFlex>دلایل عدم تایید</div>
        <button mat-mini-fab color="primary" (click)="dialogRef.close()">
            <mat-icon class="pointer">close</mat-icon>
        </button>
    </mat-toolbar>
    <mat-card-content>
        <div fxLayout="row wrap" class="pa-1">
            <div *ngFor="let problemIssueType of problemIssueTypes" fxFlex="100" fxFlex.lt-sm="100" class="pa-10">
                <mat-checkbox (change)="changNotConfirm(problemIssueType.id,$event.checked);">
                    <p class="mr-5">{{problemIssueType.title}}
                    </p>
                </mat-checkbox>
            </div>
        </div>
    </mat-card-content>
</div>
<div class="center pa-10">
    <button mat-raised-button class="" color="primary" (click)="dialogRef.close(problemIssue);">اعمال فیلتر
    </button>
</div>